<div class="nes-flex tile nes-justify-center">
  <ng-container *ngFor="let tab of tabs; index as i">
    <div
      class="tab-step nes-flex nes-items-center nes-justify-between nes-mb-5"
      (click)="tabClicked.emit(tab)"
      [ngClass]="{
        done: tab.done,
        'active ': tab.active,
        inactive: !tab.active,
        'not-allowed': tab.route > 1 && currentRoute === Route.COMPOSE
      }"
    >
      <div class="nes-flex nes-relative nes-flex-col nes-items-center">
        <div
          class="indicator_number nes-flex nes-h-10 nes-w-10 nes-rounded-full nes-justify-center nes-items-center"
          [class.submenuItem__title]="tab.active"
        >
          <div *ngIf="tab.done; else indicatorName">
            <nes-icon name="check-thick" color="white"></nes-icon>
          </div>
          <ng-template #indicatorName>
            {{ i + 1 }}
          </ng-template>
        </div>
        
        <span class="indicator_name nes-hidden sm:nes-inline nes-absolute nes-top-10">{{
          tab.title
        }}</span>
      </div>
      <div *ngIf="i < 4" class="indicator_line" [ngClass]="{
        done: tab.done,
        'active ': tab.active,
        inactive: !tab.active,
        'not-allowed': tab.route > 1 && currentRoute === Route.COMPOSE
      }"></div>
    </div>
  </ng-container>
</div>
